import ImageCard, { ImageCardProps } from './ImageCard';

export default ImageCard;
export type { ImageCardProps };
